import React from 'react';
import PropTypes from 'prop-types';
import QueueAnim from 'rc-queue-anim';
import { Button } from 'antd';
import BannerImage from './BannerImage';

class Banner extends React.PureComponent {
  static propTypes = {
    className: PropTypes.string,
  }
  static defaultProps = {
    className: 'home-banner',
  }
  render() {
    const { className } = this.props;
    return (
      <div className={`home-layout-wrapper ${className}`}>
        <div className="home-layout">
          <QueueAnim className={`${className}-content-wrapper`} delay={300} ease="easeOutQuart">
            <h1 key="h2">
              MrLTactics 一joins FM-Base
            </h1>
            <p key="p">We're completing a full merge between the two communities!</p>
            <span key="button">
              <Button
                type="primary"
                onClick={() => {
                window.location.href = 'https://fm-base.co.uk/articles/merger-announcement-mr-l-tactics-and-fm-base.110/';
              }}
              >
                Check out FM-Base announcement!
              </Button>
            </span>
          </QueueAnim>
          <div className={`${className}-image-wrapper`}>
            <BannerImage />
          </div>
        </div>
      </div>
    );
  }
}

export default Banner;
